import React from 'react'
import NoData from '@/components/common/NoData'
import LoadingSpinner from '@/components/common/LoadingSpinner'
import GeneralError from '@/components/common/GeneralError'
import DatasetTable from '@/components/pages/JobsPage/DatasetTable'

type DatasetTabProps = {
    datasetJobs: any,
    datasetsLoading: boolean,
    datasetsError: boolean,
}

const DatasetTab = ({datasetJobs, datasetsLoading, datasetsError}: DatasetTabProps) => {

    if(datasetsLoading) {
        return <LoadingSpinner />
    }

    if(datasetsError) {
        return <GeneralError />
    }

    if(!datasetJobs) {
        return <NoData message="No dataset jobs found."/>
    }

    return <DatasetTable jobs={datasetJobs || []}/>
}

export default DatasetTab